import { ACCOUNTING_STATEMENT_BREIF } from '../../constants';
import { api } from '../api';

export const accountingSlice = api.injectEndpoints({
  endpoints: (build) => ({
    getAccountingFilter: build.query<any, null>({
      query: () => `${ACCOUNTING_STATEMENT_BREIF}`,
      providesTags: ['GetAccountingBalanceFilter']
    })
  }),

  overrideExisting: false
});

export const { useGetAccountingFilterQuery, useLazyGetAccountingFilterQuery } =
  accountingSlice;
